import Level from "./Level";
import Rain from "./Rain";
import Temperature from "./Temperature";

class WeatherData {
    name: string;
    currentRain: number;
    humidity: number;
    riverLevel: number;
    temperature: number;
    temperatureFeel: number;
    riverLevelHistory: Level[];
    rainVolumes: Rain[];
    temperatureHistory: Temperature[];
    loaded: boolean = false;

    constructor(name: string, currentRain: number, humidity: number, riverLevel: number, temperature: number, temperatureFeel: number, loaded: boolean) {
        this.name = name;
        this.currentRain = currentRain;
        this.humidity = humidity;
        this.riverLevel = riverLevel;
        this.temperature = temperature;
        this.temperatureFeel = temperatureFeel;
        this.riverLevelHistory = [];
        this.rainVolumes = [];
        this.temperatureHistory = [];
        this.loaded = loaded;
    }

    setRiverLevels(levels: Level[]) {
        this.riverLevelHistory = levels;
    }

    getRiverLevels() {
        return this.riverLevelHistory;
    }

    setRainVolumes(volumes: Rain[]) {
        this.rainVolumes = volumes;
    }

    getRainVolumes() : Rain[] {
        return this.rainVolumes;
    }

    getName(): string {
        return this.name;
    }

    getCurrentRain(): number {
        return this.currentRain;
    }

    getHumidity(): number {
        return this.humidity;
    }

    getRiverLevel(): number {
        return this.riverLevel;
    }

    getTemperature(): number {
        return this.temperature;
    }

    getTemperatureFeel(): number {
        return this.temperatureFeel;
    }

    setTemperatureHistory(history: Temperature[]) {
        this.temperatureHistory = history;
    }

    getTemperatureHistory() {
        return this.temperatureHistory;
    }

    getLevelDifference(): number|null {
        if (this.riverLevelHistory && this.riverLevelHistory.length > 0) {
            const previousLevel = this.riverLevelHistory[this.riverLevelHistory.length - 2].getLevel();
            if (typeof previousLevel != 'number') {
                return null;
            }
            return this.riverLevel - this.riverLevelHistory[this.riverLevelHistory.length - 2].getLevel();
        }
        return null;
    }

    isLoaded(): boolean {
        return this.loaded;
    }
}

export default WeatherData;
